import { FaReact } from 'react-icons/fa';
import { useAuth } from '../../../hooks/useAuth.ts';
import { useCustomState } from '../../../hooks/useCustomState.ts';
import { useAccountApplications } from '../../accounts-management';
import { useEffect } from 'react';
import { useUserAccount } from '../../../hooks/useUserAccount.ts';

export const useDashboard = () => {
    const { userAccount } = useUserAccount();

    // FNP-2238: every connected application, not `visibleItems` - that is the
    // account-applications table's page (10 by default), and the dashboard has
    // no pagination control to reach the rest.
    const {
        items: accountApplications,
        loading: applicationsLoading,
        fetchRecords,
    } = useAccountApplications(userAccount?.id ?? '');

    useEffect(() => {
        if (!userAccount?.id) {
            return;
        }
        fetchRecords();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [userAccount?.id]);

    const { idToken, accessToken } = useAuth();
    const { customState, clearCustomState } = useCustomState();

    const loading = !userAccount || applicationsLoading;

    const applications = accountApplications
        .map((item) => item.application)
        .filter((app): app is NonNullable<typeof app> => app != null);

    const collection = applications.map((item) => ({
        app: item.name ?? '',
        description: item.description ?? '',
        locationOriginal:
            item.url +
            `#id_token=${idToken}&access_token=${accessToken}&token_type=Bearer&expires_in=3600&state=${customState}`,
        location: item.url + '?next=authn',
        logo: item.logoUrl ? item.logoUrl : '',
        icon: <FaReact />,
        onClick: () => {
            clearCustomState();
        },
    }));

    return {
        applications: collection,
        loading,
    };
};
